import { useCallback, useState, useContext, useEffect, Suspense } from "react";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import {
  addEmployeeRequestAccess,
  deleteEmployeeRequestAccess,
  getEmployeeRequestAccess,
} from "../TicketManagement/TicketService";
import { useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

const EmployeeRequestAccess = () => {
  const [columns, setColumns] = useState([
    "Category",
    "SubCategory",
    "Employee Name",
  ]);
  const [rows, setRows] = useState([{}]);
  const [editIndex, setEditIndex] = useState(null);
  const [ticketSubcategoryType, setTicketSubCategoryType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [empReqCategoryId, setEmpReqCategoryId] = useState(null);
  const [isLoading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [errors, setErrors] = useState({});
  const { GUID } = useParams();
  const [employeeList, setEmployeeList] = useState([]);
  const [empReqAccess, setEmpReqAccess] = useState([]);
  const [subcategoryList, setTicketSubcategoryTypeList] = useState([]);
  const [data, setData] = useState({
    CategoryId: "",
    SubCategoryId: "",
    AccessEmpId: "",
  });
  const [oldReqAccessValue , setOldReqAccessValue] = useState({});

  useEffect(() => {
    getMasterTicketCategory();
    getMasterTicketSubCategory();
    getEmployeeLists();
    GetEmpReqAccess();
  }, []);

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTicketCategoryType(data?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTicketSubcategoryTypeList(data?.Data);
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST?.MasterDataType);
      setIsloading(false);
    }
  }

  const validateRequestAccess = (data, index) => {
    const newErrors = {};
    if (!data.CategoryId || data.CategoryId.toString().trim() === "") {
      newErrors[`${index}-CategoryId`] = "Category is required";
    }

    if (!data.SubCategoryId || data.SubCategoryId.toString().trim() === "") {
      newErrors[`${index}-SubCategoryId`] = "Sub Category is required";
    }

    if (!data.AccessEmpId || data.AccessEmpId.toString().trim() === "") {
      newErrors[`${index}-AccessEmpId`] = "Employee is required";
    }
    setErrors((prev) => {
      const filteredErrors = Object.fromEntries(
        Object.entries(prev).filter(([key]) => !key.startsWith(`${index}-`))
      );
      return { ...filteredErrors, ...newErrors };
    });
    return Object.keys(newErrors).length === 0;
  };

  async function GetEmpReqAccess() {
    setIsloading(true);
    try {
      let response = await getEmployeeRequestAccess();
      setEmpReqAccess(response?.Data);
      setIsloading(false);
    } catch (err) {
      // toster.current.error(ERROR_LIST.AwardMasterData);
    } finally {
      setIsloading(false);
    }
  }

  const AccessForm = useFormik({
    initialValues: {
      CategoryId: "",
      SubCategoryId: "",
      AccessEmpId: "",
      Id: "",
      CreatedDate: "",
      CategoryName: "",
      SubCategoryName: "",
      AccessEmpName: "",
    },
    onSubmit: async (data) => {
      if (!AccessForm.isValid) {
        AccessForm.setTouched({
          CategoryId: true,
          SubCategoryId: true,
          AccessEmpId: true,
          Id: true,
          CreatedDate: true,
        });
        return;
      }

      setIsloading(true);
      const body = {
        Id: data?.Id || 0,
        GUID: GUID,
        IsActive: true,
        CreatedDate: data.CreatedDate || new Date().toISOString(),
        ModifiedDate: new Date().toISOString(),
        CreatedBy: 0,
        ModifiedBy: 0,
        OrgId: userDetails?.OrgId,
        CategoryId: data?.CategoryId,
        SubCategoryId: data.SubCategoryId,
        AccessEmpId: data.AccessEmpId,
        CategoryName: data.CategoryName,
        SubCategoryName: data.SubCategoryName,
        AccessEmpName: data.AccessEmpName,
      };
      try {
        await addEmployeeRequestAccess(body);
        if (data.Id) {
          GetMasterSystemAlertList("Award_Updated", 0);
          setEditIndex(null);
        } else {
          setEditIndex(null);
          GetMasterSystemAlertList("Award_Added", 0);
        }
        setTimeout(() => {
          GetEmpReqAccess();
        }, 1000);
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      } finally {
        setIsloading(false);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        // setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (value) {
        setEmpReqAccess((prev) =>
          prev.filter(
            (item) =>
              item.CategoryName?.toLowerCase().includes(value.toLowerCase()) ||
              item.SubCategoryName?.toLowerCase().includes(
                value.toLowerCase()
              ) ||
              item.AccessEmpName?.toLowerCase().includes(value.toLowerCase())
          )
        );
      } else {
        GetEmpReqAccess();
      }
    }, 100),
    []
  );

  const handleAddRow = () => {
    AccessForm.resetForm();
    setEmpReqAccess([
      ...empReqAccess,
      { CategoryId: "", SubCategoryId: "", AccessEmpId: "", Id: 0 },
    ]);
    setEditIndex(empReqAccess.length);
  };

  const handleEditClick = (index) => {
    setEditIndex(index);
     setOldReqAccessValue(empReqAccess[index]);
    const item = empReqAccess[index];
   
    AccessForm.setValues({
      CategoryId: item.CategoryId || "",
      SubCategoryId: item.SubCategoryId || "",
      AccessEmpId: item.AccessEmpId || "",
      Id: item.Id || 0,
    });
    const filteredSubcategoryList = subcategoryList.filter((subcategory) => {
      return String(subcategory.CategoryId) === String(item.CategoryId);
    });
    setTicketSubCategoryType(filteredSubcategoryList);
  };

  const handleEmpReqCategory = (Id) => {
    setEmpReqCategoryId(Id);
  };

  async function DeleteOrgEmpRequestAccess() {
    setIsloading(true);
    if (empReqCategoryId) {
      let body = {
        Id: empReqCategoryId,
      };
      try {
        let empReqCategoryList = await deleteEmployeeRequestAccess(body);
        if (empReqCategoryList) {
          setIsloading(false);
          GetEmpReqAccess();
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const handleCancelEdit = () => {
    setEmpReqAccess((prevList) => {
      if (
        editIndex === null ||
        editIndex < 0 ||
        editIndex === empReqAccess.length
      ) {
        const lastItem = prevList[prevList.length - 1];
        lastItem.CategoryId = "";
        lastItem.SubCategoryId = "";
        lastItem.AccessEmpId = "";
        return prevList.slice(0, -1);
      }

      const item = prevList[editIndex];

      const isEmpty =
        !item?.SubCategoryId?.toString().trim() &&
        !item?.CategoryId?.toString().trim() &&
        !item?.AccessEmpId?.toString().trim() &&
        item?.Id === 0;

      if (isEmpty || item.Id === 0) {
        const updated = [...prevList];
        updated.splice(editIndex, 1);
        return updated;
      }
      if (item?.Id > 0) {
        GetEmpReqAccess();
      }
      return prevList;
    });

    AccessForm.resetForm();
    setEditIndex(null);
  };

  async function onChangeCategoryType(e) {
    const selectedCategoryId = e?.value;
    if (!selectedCategoryId) return;
    AccessForm.setFieldValue("CategoryId", selectedCategoryId);
    if (!Array.isArray(subcategoryList)) return;
    const filteredSubcategoryList = subcategoryList.filter((subcategory) => {
      return String(subcategory.CategoryId) === String(selectedCategoryId);
    });
    setTicketSubCategoryType(filteredSubcategoryList);
  }

  async function getEmployeeLists() {
    var params1 = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeeLists = await getEmployeeList(params1);
      setEmployeeList(employeeLists.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>Employee Request Access ({empReqAccess?.length})</h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Acceess Request
              </button>
            )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {empReqAccess?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <Dropdown
                          value={AccessForm.values.CategoryId}
                          options={ticketCategoryType}
                          onChange={(e) => {
                            onChangeCategoryType(e);
                            const updatedList = [...empReqAccess];
                            updatedList[index].CategoryId = e.value;
                            setEmpReqAccess(updatedList);
                            AccessForm.setFieldTouched(
                              `empReqAccess.${index}.CategoryId`,
                              true
                            );
                            validateRequestAccess(updatedList[index], index);
                          }}
                          onBlur={() =>
                            AccessForm.setFieldTouched(
                              `empReqAccess.${index}.CategoryId`,
                              true
                            )
                          }
                          className="filledannoucement w-100"
                          optionLabel="Name"
                          optionValue="Id"
                          filter={true}
                          placeholder="Choose..."
                          checkmark={true}
                          highlightOnSelect={false}
                        />
                        {errors[`${index}-CategoryId`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-CategoryId`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <Dropdown
                          value={AccessForm.values.SubCategoryId}
                          options={ticketSubcategoryType}
                          onChange={(e) => {
                            AccessForm.setFieldValue("SubCategoryId", e.value);
                            const updatedList = [...empReqAccess];
                            updatedList[index].SubCategoryId = e.value;
                            setEmpReqAccess(updatedList);
                            AccessForm.setFieldTouched(
                              `empReqAccess.${index}.CategoryId`,
                              true
                            );
                            validateRequestAccess(updatedList[index], index);
                          }}
                          className="filledannoucement w-100"
                          optionLabel="Name"
                          optionValue="Id"
                          filter={true}
                          placeholder="Choose..."
                          checkmark={true}
                          highlightOnSelect={false}
                        />
                        {errors[`${index}-SubCategoryId`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-SubCategoryId`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <Dropdown
                          value={AccessForm.values.AccessEmpId}
                          options={employeeList}
                          onChange={(e) => {
                            AccessForm.setFieldValue("AccessEmpId", e.value);
                            const updatedList = [...empReqAccess];
                            updatedList[index].AccessEmpId = e.value;
                            setEmpReqAccess(updatedList);
                            AccessForm.setFieldTouched(
                              `empReqAccess.${index}.CategoryId`,
                              true
                            );
                            validateRequestAccess(updatedList[index], index);
                          }}
                          className="filledannoucement w-100"
                          optionLabel="FullName"
                          optionValue="EmpId"
                          filter={true}
                          placeholder="Choose..."
                          checkmark={true}
                          highlightOnSelect={false}
                        />
                        {errors[`${index}-AccessEmpId`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-AccessEmpId`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <>
                          <img
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                            onClick={handleCancelEdit}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            onClick={() => {
                              const item = empReqAccess[index];
                              AccessForm.setValues({
                                CategoryId: item.CategoryId,
                                SubCategoryId: item.SubCategoryId,
                                AccessEmpId: item.AccessEmpId,
                                Id: item.Id || 0,
                                CreatedDate:
                                  item.CreatedDate || new Date().toISOString(),
                                CategoryName: item?.CategoryName || "",
                                SubCategoryName: item?.SubCategoryName || "",
                                AccessEmpName: item?.AccessEmpName || "",
                              });
                              if (validateRequestAccess(data, index)) {
                                AccessForm.handleSubmit();
                                setEditIndex(null);
                              }
                            }}
                            className="editactions"
                            style={{ width: "17px" }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.CategoryName}</td>
                      <td>{data?.SubCategoryName}</td>
                      <td>{data?.AccessEmpName}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-requestAccess"
                          onClick={() => {
                            handleEmpReqCategory(data?.Id);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-requestAccess">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>
                  Do you really want to delete this Employee Request Access?
                </p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgEmpRequestAccess()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default EmployeeRequestAccess;
